import { FormEvent, useContext, useEffect, useState } from "react"
import { Button, Loader } from "../Styles"
import { toast } from "react-toastify"
import { listarBancoIndicador } from "../../services/bancoIndicadores"
import { IndicadoresLista } from "../../interfaces/bancoIndicador"
import { ModalEstadoContext } from "../../contexts/ModalEstado"
import Permissoes from "../../middleware/Permissoes"
import ModulosContratados from "../../middleware/SistemasContratados"
import FiltrosDefault from "../FiltrosDefault"
import LoadingBarra from "../LoadingBarra"
import NenhumResultadoEncontrado from "../NenhumResultadoEncontrato"
import Organizacao from "../../middleware/Organizacao"
import maisFiltrosImg from '../../assets/img/maisFiltros.png'
import DivSituacao from "../DivSituacao"
import ModalIndicador from "../ModalIndicador"
import "./index.css"

function BancoIndicadores() {
    const { modal, modalExibir, atualizarInformacoes } = useContext(ModalEstadoContext)

    const [processando, setProcessando] = useState(false);
    const [nenhumResultado, setNenhumResultado] = useState(false);
    const [situacao, setSituacao] = useState("");
    const [titulo, setTitulo] = useState("");
    const [maisFiltros, setMaisFiltros] = useState(false)
    const [grupo, setGrupo] = useState("");
    const [indicadores, setIndicadores] = useState<IndicadoresLista[]>([]);
    const [indicadorSelecionado, setIndicadorSelecionado] = useState<IndicadoresLista>();

    const modalMaisFiltros = () => setMaisFiltros(!maisFiltros)

    const filtrar = async (e: FormEvent) => {
        e.preventDefault()
        setProcessando(true)
        setNenhumResultado(false)

        try {
            const queryParams = {
                titulo,
                situacao,
                grupo
            }

            const resposta = await listarBancoIndicador(queryParams)

            setIndicadores(resposta.data)
            if (resposta.status === 200 && resposta.data.length === 0) {
                setMaisFiltros(false)
                setNenhumResultado(true)
                return setProcessando(false)
            }
            setMaisFiltros(false)
            return setProcessando(false)
        } catch (error) {
            setProcessando(false)
            return toast.error("Erro ao Buscar os Indicadores")
        }
    }

    const abrirModalEditarIndicador = (indicador: IndicadoresLista) => {
        setIndicadorSelecionado(indicador);
        modalExibir("ModalIndicador")
    }

    const abrirModalCadastrarIndicador = () => {
        setIndicadorSelecionado(undefined);
        modalExibir("ModalIndicador");
    }

    useEffect(() => {
        const buscarIndicador = async () => {
            setProcessando(true)
            try {
                const queryParams = {
                    titulo: "",
                    situacao: "",
                    grupo: ""
                }

                const resposta = await listarBancoIndicador(queryParams)

                if (resposta.status === 200 && resposta.data.length === 0) {
                    setNenhumResultado(false)
                    return setProcessando(false)
                }

                setIndicadores(resposta.data)
                return setProcessando(false)

            } catch (error) {
                setProcessando(false)
                return toast.error("Erro ao Buscar os Indicadores")
            }
        }
        buscarIndicador()
    }, [atualizarInformacoes])

    return (
        <Organizacao organizacao={[`${process.env.REACT_APP_ORGANIZACAO_HG}`]}>
            <ModulosContratados modulo={["Projetos"]}>
                <Permissoes permissoes={['master', 'administrativo', 'projeto_banco_indicadores']}>
                    <div id='paginaContainer'>
                        {modal.nome === "ModalIndicador" && <ModalIndicador indicador={indicadorSelecionado} />}
                        {processando && <LoadingBarra />}
                        {nenhumResultado && <NenhumResultadoEncontrado />}
                        <FiltrosDefault termo={titulo} situacao={situacao} placeholder='Pesquise pelo Titulo' tipo={"Indicador"} onChangeTermo={(e) => setTitulo(e.target.value)} onChangeSituacao={(e) => { setSituacao(e.target.value) }} acaoBtn={abrirModalCadastrarIndicador} listaSituacao={[{ nome: 'Todos', valor: '' }, { nome: 'Ativo', valor: 'Ativo' }, { nome: 'Inativo', valor: 'Inativo' }]} genero='masculino' isLoading={processando} maisFiltros={true} acaoMaisFiltro={modalMaisFiltros} onSubmit={filtrar} />
                        {maisFiltros && <section id='maisOpcoesFiltrosTarefas'>
                            <form id='maisOpcoesFiltrosTarefasContainer' onSubmit={filtrar}>
                                <span id='filtrosContainerTitulo'>
                                    <img id='filtrosAvancadosTarefas' src={maisFiltrosImg} alt='' />
                                    <p>Filtros Avançados</p>
                                </span>
                                <section id='opcoesFiltrosTarefas'>
                                    <section>
                                        <span>
                                            <label htmlFor="grupo">Grupo</label>
                                            <select name="grupo" onChange={(e) => setGrupo(e.target.value)} defaultValue={grupo}>
                                                <option value="">Todos</option>
                                                <option value="Gestão Financeira">Gestão Financeira</option>
                                                <option value="Gestão de Pessoas">Gestão de Pessoas</option>
                                                <option value="Desenvolvimento de Software">Desenvolvimento de Software</option>
                                                <option value="Outros">Outros</option>
                                            </select>
                                        </span>
                                    </section>
                                </section>
                                <span id="botoesContainerFiltrosTarefas">
                                    <Button type='button' cor='cancelar' isLoading={processando} onClick={modalMaisFiltros}>Cancelar</Button>
                                    <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                                        {!processando && 'Buscar Dados'}
                                        {processando && <Loader isLoading={processando} />}
                                    </Button>
                                </span>
                            </form>
                        </section>}
                        <section id='fundoContainerPagina'>
                            <section className="lista-indicadores">
                                {indicadores.map((indicador) => (
                                    <section className="container-indicador" onClick={() => abrirModalEditarIndicador(indicador)}>
                                        <span className="header-container-indicador">
                                            <span className="nome-sigla-indicador">
                                                <h1>{indicador.titulo}</h1>
                                                <p>{indicador.sigla}</p>
                                            </span>
                                            <span className="situacao-indicador">
                                                <DivSituacao texto={indicador.situacao} cor={indicador.situacao.toLowerCase()} />
                                            </span>
                                        </span>
                                        <span className="descricao-indicador">
                                            <h3>Descrição</h3>
                                            <p>
                                                {indicador.descricao}
                                            </p>
                                        </span>
                                        <br />
                                        <span className="descricao-indicador">
                                            <h3>Metodologia</h3>
                                            <p>
                                                {indicador.metodologia}
                                            </p>
                                        </span>
                                    </section>
                                ))}
                            </section>
                        </section>
                    </div>
                </Permissoes>
            </ModulosContratados>
        </Organizacao>
    )
}

export default BancoIndicadores
